import React from 'react';

function BuyNow(props) {
    return (
        <div className={'BuyNow'}>
            <a>BUY NOW<span></span></a>
        </div>
    );
}

export default BuyNow;
